jQuery(function () {

    //    document.getElementById("btnPrint").onclick = function () {
    //   		printElement(document.getElementById("printThis"));
    // };

    jQuery('form#netsuiteForm').submit(function () {
        jQuery(this).find('input[type=submit]').prop('disabled', true)
        jQuery('label#submitBtn').addClass('disabled')
        jQuery('#confirmBtn').addClass('disabled')
        jQuery('input#submitter').addClass('disabled')
    })

    // document.getElementById("btnPrint").onclick = function () {
    //    printElement(document.getElementById("printThis"));
    // }

    // function printElement(elem) {
    //     var domClone = elem.cloneNode(true);

    //     var jQueryprintSection = document.getElementById("printSection");

    //     if (!jQueryprintSection) {
    //         var jQueryprintSection = document.createElement("div");
    //         jQueryprintSection.id = "printSection";
    //         document.body.appendChild(jQueryprintSection);
    //     }

    //     jQueryprintSection.innerHTML = "";
    //     jQueryprintSection.appendChild(domClone);
    //     window.print();
    // }

    // function printElement(elem) {
    //     var domClone = elem.cloneNode(true);

    //     var jQueryprintSection = document.getElementById("printSection");

    //     if (!jQueryprintSection) {
    //         var jQueryprintSection = document.createElement("div");
    //         jQueryprintSection.id = "printSection";
    //         document.body.appendChild(jQueryprintSection);
    //     }

    //     jQueryprintSection.innerHTML = "";
    //     jQueryprintSection.appendChild(domClone);
    //     window.print();
    // }

    //Hide conditional fields
    jQuery('#dropOff').hide()
    jQuery('#dropOffB').hide()
    jQuery('#shipOptions').hide()
    jQuery('#shipOptionsB').hide()
    jQuery('.shippingNote').hide()
    jQuery('#disclaimer').hide()
    jQuery('#appleDisclaimer').hide()
    jQuery('#pcDisclaimer').hide()
    jQuery('#waiver').hide()
    jQuery('#waiverPrint').hide()
    jQuery('#textOpt').hide()
    jQuery('#refreshLevels').hide()

    var termsValue = jQuery(".terms").text()
    jQuery("textarea[name='custevent165']").val(termsValue)

    jQuery('input[name="proceedOps"]').on("change", function () {
        var value = jQuery(this).attr("value")

        if (value == 'I will ship in my device') {
            jQuery('#shipOptions').show()
            jQuery('#shipOptions select').prop('required', true)
            jQuery('select[name="shipOptions"]').on("change", function () {
                var shipOps = value + ' ' + jQuery(this).attr("value")
                jQuery('#requestType').val(shipOps)
            })
        } else {
            jQuery('#shipOptions').hide()
            jQuery('select[name="shipOptions"]').val('')
            jQuery('.shippingNote').hide()
            jQuery('#shipOptions select').prop('required', false)
            jQuery('#requestType').val(value)
        }

        if (value == "I will drop off my unit") {
            jQuery('#dropOff').show()
            jQuery('#dropOff input[name="custevent140"]').prop('required', true)
        } else {
            jQuery('#dropOff').hide().val('')
            jQuery('#dropOff input[name="custevent140"]').prop('required', false)
        }

        if (value == "Please pickup from my business") {
            jQuery('#disclaimer').show()
        } else {
            jQuery('#disclaimer').hide()
        }

        if (value == "Please pickup curbside from my residental address") {
            jQuery('#textOpt').show()
            jQuery('#textPhone').prop('required', true)
            jQuery('#optIn').prop('required', true)
        } else {
            jQuery('#textOpt').hide()
            jQuery('#optIn').prop('checked', false)
            jQuery('#optIn').removeAttr('required')
            jQuery('#textPhone').val('')
            jQuery('#textPhone').removeAttr('required')
            jQuery("select[name='custevent163']").val('')
            jQuery("input[name='custevent162']").val('')
        }
    })

    jQuery("select[name='shipOptions']").on("change", function () {
        if (jQuery(this).attr("value") == " - CCare to send a box.") {
            jQuery('.shippingNote').show()
        } else {
            jQuery('.shippingNote').hide()
        }
    })
    jQuery('#textPhone').change(function () {
        var number = jQuery('input[name="textPhone"]').val()
        var prefix = '+1'
        var mobile = prefix + number
        jQuery("input[name='custevent162']").val(mobile)
    })

    jQuery('#optIn').change(function () {
        var c = this.checked ? '2' : ' '
        jQuery("select[name='custevent163']").val(c)
    })

    var termsValue = jQuery(".terms").text()
    jQuery("textarea[name='custevent165']").val(termsValue)

    //Auto fill first and last name to single name field
    var valueName
    jQuery('#first').change(function () {
        valueName = jQuery(this).val()
    })
    jQuery('#last').change(function () {
        valueName += " " + jQuery(this).val()
        jQuery('#name').val(valueName)
        jQuery('#bill_name').val(valueName)
        jQuery("#contact_name").val(valueName)
    })

    //Fill fields based on Address selection
    jQuery("input[name='billingType']").on("change", function () {
        //If shipping/billing are the same, hide billing and copy shipping address to billing and default
        if (jQuery(this).attr("value") == "same") {
            var bill = jQuery(this).attr("value") == "same"
            jQuery("[id^='bill_']").each(function () {
                var tmpID = this.id.split('bill_')[1]
                jQuery(this).val(bill ? jQuery("#" + tmpID).val() : "")
            })
            var deflt = jQuery(this).attr("value") == "same"
            jQuery("[id^='default_']").each(function () {
                var tmpID = this.id.split('default_')[1]
                jQuery(this).val(deflt ? jQuery("#" + tmpID).val() : "")
            })
            jQuery("[id^='bill_']").each(function () {
                jQuery(this).prop('required', false)
            })
            jQuery('#billAddr').hide()
        } else {
            //If billing on file, remove values from default fields
            if (jQuery(this).attr("value") == "existing") {
                jQuery("[id^='bill_']").each(function () {
                    jQuery(this).val('')
                    jQuery(this).prop('required', false)
                })
                jQuery("[id^='default_']").each(function () {
                    jQuery(this).val('')
                })
                jQuery('#billAddr').hide()
            } else {
                if (jQuery(this).attr("value") == "different") {
                    jQuery("[id^='bill_']").each(function () {
                        jQuery(this).val('')
                    })
                    jQuery('#bill_name').prop('required', true)
                    jQuery('#bill_address1').prop('required', true)
                    jQuery('#bill_city').prop('required', true)
                    jQuery('#bill_state').prop('required', true)
                    jQuery('#bill_zip').prop('required', true)
                    jQuery('#billAddr').show()
                    jQuery('#bill_name').val(valueName)
                    jQuery("[id^='default_']").each(function () {
                        jQuery(this).val('')
                    })
                    jQuery('input[name=custevent144]').change(function () {
                        var addr1 = jQuery('input[name=custevent144]').val()
                        jQuery('#default_address1').val(addr1)
                    })
                    jQuery('input[name=custevent145]').change(function () {
                        var addr2 = jQuery('input[name=custevent145]').val()
                        jQuery('#default_address2').val(addr2)
                    })
                    jQuery('input[name=custevent146]').change(function () {
                        var city = jQuery('input[name=custevent146]').val()
                        jQuery('#default_city').val(city)
                    })
                    jQuery('select[name=custevent147]').on("change", function () {
                        var state = jQuery('select[name=custevent147]').val()
                        jQuery('#default_state').val(state)
                    })
                    jQuery('input[name=custevent148]').change(function () {
                        var zip = jQuery('input[name=custevent148]').val()
                        jQuery('#default_zip').val(zip)
                    })
                }
            }
        }
    })

    //Feed Address Type to NetSuite Form
    jQuery("input[name='billingType']").on("change", function () {
        var value = jQuery(this).attr("value")
        jQuery('#addressType').val(value)
    })

    //Show iphone waiver based on 'Machine Type' selection
    jQuery("select[name='custevent121']").on("change", function () {
        if ((jQuery(this).val() == "2") || (jQuery(this).val() == "4")) {
            jQuery('#waiver').show()
            jQuery('#waiverPrint').show()
            jQuery('input[name="custevent141"]').prop('required', true)
        } else {
            jQuery('#waiver').hide()
            jQuery('input[name="custevent141"]').prop('required', false)
            jQuery('#waiverPrint').hide()
        }
    })

    //Show disclaimers based on 'Machine Type' selection
    jQuery("select[name='custevent120']").on("change", function () {
        if ((jQuery(this).val() == "1")) {
            jQuery('#appleDisclaimer').show()
            jQuery('#pcDisclaimer').hide()
        } else {
            jQuery('#pcDisclaimer').show()
            jQuery('#appleDisclaimer').hide()
        }
    })

    jQuery('#symptom').on("input", function () {
        var maxlength = jQuery(this).attr("maxlength")
        var currentLength = jQuery(this).val().length

        if (currentLength >= maxlength) {
            jQuery('#symptomChar').text("You have reached the maximum number of characters.")
        } else {
            jQuery('#symptomChar').text(maxlength - currentLength + ' characters left')
        }

    })

    jQuery('input[name="refreshChoice"]').on("change", function () {
        var value = jQuery(this).attr("value")
        if (value == 'yes') {
            jQuery('#refreshLevels').show()
            jQuery('input[name="refreshOps"]').prop('required', true)
            jQuery('input[name="stickerOps"]').prop('required', true)
        } else {
            jQuery('#refreshLevels').hide()
            jQuery('input[name="custevent167"]').prop('required', false)
            jQuery('input[name="stickerOps"]').prop('required', false)
            jQuery('input[name="refreshOps"]').val('')
            jQuery('input[name="stickerOps"]').val('')
        }
    })

    jQuery('input[name="refreshOps"]').on("change", function () {
        var value = jQuery(this).attr("value")
        jQuery('input[name="custevent167"]').val(value)
    })

    jQuery('input[name="stickerOps"]').on("change", function () {
        var value = jQuery(this).attr("value")
        jQuery('input[name="custevent168"]').val(value)
    })

    jQuery('.button').click(function () {

        var serviceType = jQuery('input[name=custevent153]').val()
        jQuery('#servicePrint').html('<li><b>Service Type:</b> <span class="input">' + serviceType + '</span></li>')

        var fname = jQuery('input[name=firstname]').val()
        var lname = jQuery('input[name=lastname]').val()
        jQuery('#namePrint').html('<li><b>Name:</b> <span class="input">' + fname + '&nbsp;' + lname + '</span></li>')

        var email = jQuery('input[name=email]').val()
        jQuery('#emailPrint').html('<li><b>Email:</b> <span class="input">' + email + '</span></li>')

        var phone = jQuery('input[name=phone]').val()
        jQuery('#phonePrint').html('<li><b>Phone:</b> <span class="input">' + phone + '</span></li>')

        var company = jQuery('input[name=companyname]').val()
        jQuery('#companyPrint').html('<li><b>Company:</b> <span class="input">' + company + '</span></li>')

        var shipname = jQuery('input[name=custevent_absi_ship_name]').val()
        jQuery('#shipNamePrint').html('<li><b>Pickup/Shipping Name:</b> <span class="input">' + shipname + '</span></li>')

        var shipattn = jQuery('input[name=custevent_absi_ship_attn]').val()
        jQuery('#shipAttnPrint').html('<li><b>Pickup/Shipping Attention:</b> <span class="input">' + shipattn + '</span></li>')

        var shipadd1 = jQuery('input[name=custevent_absi_ship_addr1]').val()
        jQuery('#shipAdd1Print').html('<li><b>Pickup/Shipping Address Line 1:</b> <span class="input">' + shipadd1 + '</span></li>')

        var shipadd2 = jQuery('input[name=custevent_absi_ship_addr2]').val()
        jQuery('#shipAdd2Print').html('<li><b>Pickup/Shipping Address Line 2:</b> <span class="input">' + shipadd2 + '</span></li>')

        var shipCity = jQuery('input[name=custevent_absi_ship_city]').val()
        jQuery('#shipCityPrint').html('<li><b>Pickup/Shipping City:</b> <span class="input">' + shipCity + '</span></li>')

        var shipState = jQuery('select[name=custevent_absi_ship_state] option:selected').text()
        jQuery('#shipStatePrint').html('<li><b>Pickup/Shipping State:</b> <span class="input">' + shipState + '</span></li>')

        var shipZip = jQuery('input[name=custevent_absi_ship_zip]').val()
        jQuery('#shipZipPrint').html('<li><b>Pickup/Shipping Zip:</b> <span class="input">' + shipZip + '</span></li>')

        var billType = jQuery('input[name=billingType]:checked').next('label').text()
        jQuery('#billTypePrint').html('<li><b>Billing Address is:</b> <span class="input">' + billType + '</span></li>')

        var billname = jQuery('input[name=custevent143]').val()
        jQuery('#billNamePrint').html('<li><b>Billing Name:</b> <span class="input">' + billname + '</span></li>')

        var billattn = jQuery('input[name=custevent142]').val()
        jQuery('#billAttnPrint').html('<li><b>Billing Attention:</b> <span class="input">' + billattn + '</span></li>')

        var billadd1 = jQuery('input[name=custevent144]').val()
        jQuery('#billAdd1Print').html('<li><b>Billing Address Line 1:</b> <span class="input">' + billadd1 + '</span></li>')

        var billadd2 = jQuery('input[name=custevent145]').val()
        jQuery('#billAdd2Print').html('<li><b>Billing Address Line 2:</b> <span class="input">' + billadd2 + '</span></li>')

        var billCity = jQuery('input[name=custevent146]').val()
        jQuery('#billCityPrint').html('<li><b>Billing City:</b> <span class="input">' + billCity + '</span></li>')

        var billState = jQuery('select[name=custevent147] option:selected').text()
        jQuery('#billStatePrint').html('<li><b>Billing State:</b> <span class="input">' + billState + '</span></li>')

        var billZip = jQuery('input[name=custevent148]').val()
        jQuery('#billZipPrint').html('<li><b>Billing Zip:</b> <span class="input">' + billZip + '</span></li>')

        var manufacturer = jQuery('select[name=custevent120] option:selected').text()
        jQuery('#manuPrint').html('<li><b>Manufacturer:</b> <span class="input">' + manufacturer + '</span></li>')

        var machineType = jQuery('select[name=custevent121] option:selected').text()
        jQuery('#machinePrint').html('<li><b>Machine Type:</b> <span class="input">' + machineType + '</span></li>')

        if (jQuery('input[name=custevent141]').is(':checked')) {
            jQuery('#waiverPrint').html('<li><b>I have read and agreed to the iPhone/iPad conditions.</b></li>')
        } else {
            jQuery('#waiverPrint').html('<li style="color: red;"><b>You have not agreed to the iPhone/iPad conditions.</b></li>')
        }

        var serial = jQuery('input[name=custevent119]').val()
        jQuery('#serialPrint').html('<li><b>Serial Number:</b> <span class="input">' + serial + '</span></li>')

        var model = jQuery('input[name=custevent124]').val()
        jQuery('#modelPrint').html('<li><b>Machine Model Name or Number:</b> <span class="input">' + model + '</span></li>')

        var partType = jQuery('input[name=custevent125]').val()
        jQuery('#partTypePrint').html('<li><b>Part/Type/Product Number:</b> <span class="input">' + partType + '</span></li>')

        var assetTag = jQuery('input[name=custevent138]').val()
        jQuery('#assetTagPrint').html('<li><b>Asset Tag:</b> <span class="input">' + assetTag + '</span></li>')

        var customerRef = jQuery('input[name=custevent14]').val()
        jQuery('#customerRefPrint').html('<li><b>Customer Reference #:</b> <span class="input">' + customerRef + '</span></li>')

        var symptoms = jQuery('input[name=title]').val()
        jQuery('#symptomsPrint').html('<li><b>Symptoms/Needs:</b> <span class="input">' + symptoms + '</span></li>')

        var serviceOps = jQuery('input[name=personalOps]:checked').next('label').text()
        jQuery('#serviceOpsPrint').html('<li><b>How should we proceed?</b><br /> <span class="input">' + serviceOps + '</span></li>')

        var bserviceOps = jQuery('input[name=businessOps]:checked').next('label').text()
        jQuery('#bserviceOpsPrint').html('<li><b>How should we proceed?</b><br /> <span class="input">' + bserviceOps + '</span></li>')

        var refreshOpsChoice = jQuery('input[name=refreshOps]:checked').next('label').text()
        jQuery('#refreshOpsPrint').html('<li><b>Redeployment/Refresh Package Level: </b><br /> <span class="input">' + refreshOpsChoice + '</span></li>')

        var stickersOpsChoice = jQuery('input[name=stickerOps]:checked').next('label').text()
        jQuery('#stickersOpsPrint').html('<li><b>Stickers: </b><br /> <span class="input">' + stickersOpsChoice + '</span></li>')

        var dropoff = jQuery('input[name=custevent140]').val()
        jQuery('#dropoffPrint').html('<li><b>Expected Drop-off Date:</b> <span class="input">' + dropoff + '</span></li>')

        jQuery(".input:empty").parent().hide()
    })
})
